import FlexiRewardsErrorCodes from "../../errorCodes/FlexiRewards"

interface TErrorsMap {
  [key: string]: string
}
const ErrorsMap: TErrorsMap = {
  [FlexiRewardsErrorCodes.PBBulkRewardProcessing]: "errors.PBFlexiPointsAppExistingBulkRewardProcessing"
}
export default (code: string) => ErrorsMap[code] || ""
